import { intlPluralrulesPolyfill } from './intl-pluralrules';
import { intlRelativetimeformatPolyfill  } from './intl-relativetimeformat';

export function loadPolyfills() {
  intlPluralrulesPolyfill();
  intlRelativetimeformatPolyfill();
}
